import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
//import 'bootstrap/dist/css/bootstrap.min.css';
import './Form.css';
import { notifyApplicationDraftSaved } from '../lib/applicationDrafts';
import { requiredFieldClass } from '../lib/requiredFieldClass';
import { applicationSuccessMessage } from '../lib/applicationSuccessMessage';

const DRAFT_KEY = 'draft_retirement';

const RetirementForm = ({ onBack, onNext, isFirstForm, isLastForm, isMultiForm, id, isDraft }) => {
    const REASONS = ["自己都合", "定年退職", "懲戒免職", "その他"];
    // フォームデータの状態を管理
    const [formData, setFormData] = React.useState({
        startDate: '',
        applicationDate: '',
        endDate: '',
        reason: ''
    });

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        try {
            const saved = localStorage.getItem(DRAFT_KEY);
            if (saved) {
                const parsed = JSON.parse(saved);
                setFormData(prev => ({ ...prev, applicationDate: parsed.applicationDate || '', endDate: parsed.endDate || '', reason: parsed.reason || '' }));
            }
        } catch (_) {}
    }, []);

    const handleSaveDraft = () => {
        localStorage.setItem(DRAFT_KEY, JSON.stringify({ applicationDate: formData.applicationDate, endDate: formData.endDate, reason: formData.reason }));
        notifyApplicationDraftSaved();
        alert('一時保存しました。申請一覧では「一時保存」と表示されます。');
    };

    const handleDeleteDraft = async () => {
        const confirmDelete = window.confirm("この下書き（一時保存データ）を削除してもよろしいですか？\n※削除すると元に戻せません。");
        if (!confirmDelete) return;

        setLoading(true);
        try {
            if (id) {
                await api.delete(`/api/applications/drafts/${id}/`);
            }    
            // ローカルでも削除
            localStorage.removeItem(DRAFT_KEY);
            alert('下書きを削除しました。');
            navigate('/applications');
        } catch (error) {
            console.error('下書きの削除に失敗:', error);
            alert('下書きの削除に失敗しました。もう一度お試しください。');
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => { if (onBack) onBack(); else navigate('/applications'); };

    // フォーム入力の変更を処理
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    useEffect(() => {
    (async () => {
        try {
            const res = await api.get("/api/me/");
            const me = res.data;

        const toInputDate = (dateStr) => {
                if (!dateStr) return "";
                const [y, m, d] = dateStr.split(/[/-]/);
                return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
            };
            
            setFormData((prev) => ({
                ...prev,
                startDate: toInputDate(me.startDate),  
            }));
        } catch (e) {
            alert("認証エラー。再ログインしてください。");
            navigate("/m/login");
            }
        })();
    }, [navigate]);

    // フォームの送信を処理
    const handleSubmit = async (e) => {
        e.preventDefault();

        const isConfirmed = window.confirm("退職届申請を送信してもよろしいですか？");
    
        if (!isConfirmed) {
            return; 
        }

        const payload = {
            applicationDate: formData.applicationDate,
            startDate: formData.startDate,
            endDate : formData.endDate,
            reason : formData.reason,
        }

        if (formData.applicationDate > formData.endDate) {
            alert('申請日は終了日より前を指定してください。');
            return;
        }


        try {
            await api.post('/api/forms/submit_retirement/', payload);
            localStorage.removeItem(DRAFT_KEY);
            alert(
                applicationSuccessMessage('退職届が正常に提出されました。', [
                    '申請一覧から内容・状態を確認できます。',
                ])
            );
            navigate('/applications');

        } catch (error) {
            console.error('Submission failed:', error);
            alert('申請に失敗しました。もう一度お試しください。');
            
            setFormData({
                applicationDate: '',
                startDate:'',
                endDate:'',
                reason: ''
            });
        }
    };

    const canSubmit = useMemo(
        () => Boolean(formData.applicationDate && formData.endDate && formData.reason?.trim()),
        [formData.applicationDate, formData.endDate, formData.reason]
    );

    return (
        <div className="container form-container">
            <h3>退職届</h3>
            <form onSubmit={handleSubmit}>
                {/*}
                <div className="mb-3">
                    <label htmlFor="startDate" className="form-label">入社日</label>
                    <input type="date" id="startDate" name="startDate" className="form-control" value={formData.startDate} onChange={handleInputChange} readOnly />
                </div>
                */}
                 <div className="mb-3">
                    <label htmlFor="applicationDate" className="form-label">申請日</label>
                    <input type="date" id="applicationDate" name="applicationDate" className={requiredFieldClass(formData.applicationDate)} value={formData.applicationDate} onChange={handleInputChange} required />
                </div>
                <div className="mb-3">
                    <label htmlFor="endDate" className="form-label">退職日:</label>
                    <input type="date" id="endDate" name="endDate" className={requiredFieldClass(formData.endDate)} value={formData.endDate} onChange={handleInputChange} required />
                </div>
               
                <div className="mb-3">
                    <label htmlFor="reason" className="form-label">理由</label>   
                    <select
                        id="reason"
                        name="reason"
                        className={requiredFieldClass(formData.reason)}
                        value={formData.reason}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">-- 選択 --</option>
                        {REASONS.map((r) => (
                            <option key={r} value={r}>{r}</option>
                        ))}
                    </select>
                </div>
                
            
            <div className="button-group">
                <button type="submit" className="btn-submit" disabled={!canSubmit}>申請</button>
                <button type="button" className="btn-draft" onClick={handleSaveDraft}>一時保存</button>
                {((id && isDraft) || localStorage.getItem(DRAFT_KEY)) && <button type="button" className="btn-delete-draft" onClick={handleDeleteDraft} disabled={loading}>下書削除</button>}
                <button type="button" className="btn-back" onClick={handleBack}>{onBack && !isFirstForm ? '前へ' : '戻る'}</button>
                {isMultiForm && onNext && <button type="button" className="btn-nav" onClick={onNext}>{isLastForm ? '完了' : '次へ'}</button>}
            </div>
            </form>
        </div>

    )
};

export default RetirementForm;